<template>
  <div>
    <v-container>
      <v-row>
        <v-col>
          <div class="mb-10">
            <DateAndQtySelection/>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-tabs v-model="tab" background-color="#DBDBDB" show-arrows>
            <v-tab v-for="(productType, i) of productType.productsTypes" :key="i">
              {{ productType|appTranslate('name') }}
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab" style="width: 100%">
            <v-tab-item v-for="(pType, j) of productType.productsTypes" :key="j">
              <v-tabs v-model="subTab" show-arrows background-color="white">
                <v-tab v-for="(gender, k) of data.genders" :key="k">
                  {{ gender|appTranslate('name') }}
                </v-tab>
              </v-tabs>
              <v-tabs-items v-model="subTab">
                <v-tab-item v-for="(gender, l) of data.genders" :key="l">
                  <v-container fluid>
                    <v-row>
                      <v-col v-for="(product, m) of filteredProducts(j, gender.id)" :key="m" cols="12" md="6" lg="3">
                        <ProductCard :number-of-days="getNumberOfDays()" :product="product" :api-url="apiUrl"
                                     :data="data" v-on:add-product-in-cart="openAddCartProductDialog($event)"/>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-tab-item>
              </v-tabs-items>
            </v-tab-item>
          </v-tabs-items>
        </v-col>
      </v-row>
    </v-container>
    <div class="grey lighten-4 py-6">
      <v-container>
        <v-row>
          <v-col cols="12" sm="12" class="text-center">
            <v-btn large class="font-weight-bold" color="primary" @click="showCart"
                   :disabled="!getProductsFromCartCount()">
              <v-icon left>mdi-chevron-right</v-icon>
              {{ 'view_order'|globalTranslate }}
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <v-snackbar v-model="snackbar" timeout="2000" :top="true" :right="true" :color="snackbarColor">{{ snackbarMsg }}</v-snackbar>
    <CartProductDialog
        @valid="addCartProductInCart"
        @cancel="cartProductDialog = false"
        v-on:click:outside="cartProductDialog = false"
        v-bind:cart-product="cartProductToAdd"
        v-bind:api-url="apiUrl"
        v-bind:is-active="cartProductDialog"
        v-bind:data="data"
        v-bind:number-of-days="getNumberOfDays()"
    />
  </div>
</template>

<script>
import {mapState, mapGetters} from "vuex";
import store from "@/store/store";
import snackbarMixin from "@/mixins/snackbarMixin";
import ProductCard from "@/components/ProductCard.vue";
import DateAndQtySelection from "@/components/DateAndQtySelection";
import CartProductDialog from "@/components/CartProductDialog";
import Config from "@/config.js";
import NProgress from "nprogress";
import cartProductModel from "@/models/cartProduct";

// We do not put this method in methods because 'this' is not defined in "beforeRouteEnter" hook
function getProductsTypes(routeTo, next) {
  const p1 = store.dispatch("productType/fetchProductsTypes");
  const p2 = store.dispatch("data/fetchData");

  return Promise
      .all([p1, p2])
      .then(() => {
        next();
      })
      .catch(error => {
        console.error(error);
        if (error.response && error.response.status == 404) {
          next({name: '404'})
        } else {
          next({name: 'network-issue'});
        }
      });
}

export default {
  name: "ProductList",
  components: {
    CartProductDialog,
    DateAndQtySelection,
    ProductCard
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    getProductsTypes(routeTo, next);
  },
  beforeRouteLeave(to, from, next) {
    NProgress.start();
    const count = this.getProductsFromCartCount();
    if (!count) {
      this.showSnackBar("Votre panier est vide !", "error");
      NProgress.done();
      return;
    }

    this.showSnackBar("Enregistrement confirmé, redirection...", "success");
    setTimeout(() => {
      next();
    }, 500);
  },
  beforeRouteUpdate(routeTo, routeFrom, next) {
    getProductsTypes(routeTo, next);
  },
  computed: {
    ...mapState(["productType", "cart", "data"]),
    ...mapGetters({
      getDiscountPercent: "cart/getDiscountPercent",
      getNumberOfDays: "cart/getNumberOfDays",
      getProductsFromCart: "cart/getProducts",
      getProductsFromCartCount: "cart/getProductsCount",
      getTotalTtc: "cart/getTotalTtc",
      getTotalWithoutDiscountTtc: "cart/getTotalWithoutDiscountTtc",
      getTvaRate: "getTvaRate",
      getWarrantyTtc: "cart/getWarrantyTtc",
    })
  },
  created() {
    this.tvaRate = this.getTvaRate();
    if (this.cart.warranty) {
      this.warranty = true;
    }

  },
  data() {
    return {
      addProductDialog: false,
      apiUrl: Config.API_URL,
      cartProductDialog: false,
      cartProductToAdd: null,
      infoDialog: false,
      productsTabs: [],
      productToAdd: null,
      selectRules: [
        value => !!value.id || 'Ce champ est requis'
      ],
      subTab: null,
      tab: null,
      tvaRate: 0,
      warranty: false
    }
  },
  methods: {
    addCartProductInCart(cartProduct) {
      this
          .$store
          .dispatch("cart/add", cartProduct)
          .then(() => {
            this.cartProductDialog = false;
            this.showSnackBar("Produit ajouté !", "success");
          })
          .catch(e => {
            console.log(e);
          });
    },
    openAddCartProductDialog(payload) {
      const cartProduct = new cartProductModel();
      cartProduct.hydrate({
        owner: "",
        product: payload.product,
        qty: this.getNumberOfDays(),
        equipments: [...payload.equipments]
      });
      this.cartProductToAdd = cartProduct;
      this.cartProductDialog = true;
    },
    filteredProducts(genderTabId, genderId) {
      // Use cache if available
      /*if (void 0 !== this.productsTabs[genderTabId]) {
        return this.productsTabs[genderTabId];
      }*/

      const products = [];
      for (let product of this.productType.productsTypes[genderTabId].products) {
        if (product.gender.id === genderId) {
          products.push(product);
        }
      }
      this.productsTabs[genderTabId] = products;

      return products;
    },
    // Return only genders with products
    /*filteredGenders(productsTabId, productTypeId) {
      let genders = [];
    }*/
    showCart() {
      this.$emit("show-cart");
    },
    updateCart() {
      this.$store.dispatch("cart/update");
    },
  },
  mixins: [snackbarMixin]
};
</script>

<style scoped>
.disabled-box {
  opacity: 0.5;
}

.red--text .range,
.grey--text .range,
.black--text .range,
.blue--text .range {
  color: inherit;
}

hr {
  border: 2px solid grey;
}
</style>
